// extracted by mini-css-extract-plugin
export default {"cls1":"WnnOh8pxAUzhXKFo9fNf","cls2":"xRTGyIth5ybW08R_dS3p WnnOh8pxAUzhXKFo9fNf"};